







































































































import {Component, Prop, Vue} from "vue-property-decorator";
import axios, {AxiosInstance, AxiosResponse} from "axios";
import {
  Configuration,
  EventSeatSmallDto,
  PagedResultOfEventSeatSmallDto,
  PagedResultOfSubscriptionSeatSmallDto,
  ReservationSeatStatusDto,
  SubscriptionSeatSmallDto,
  ReservationsApi,
  SeatsApi, PublicUpdateEventReservationModel, SeatConfigurationDto, Pricing, PublicUpdateSubscriptionReservationModel
} from "../../api";
import {TicketSelectionMapController} from "./TicketSelectionMapController";
import {IEventListener} from "../../shared_components/seating-chart-2/IEventListener";
import ReservationItem from "./reservation-item.vue";
import ReservationItemReadonly from "./reservation-item-readonly.vue";
import {ReservationInfo, SeatSelection} from "./models/SeatSelection";
import {SeatReservationService} from "./SeatReservationService";
import {Seat} from "../../shared_components/seating-chart-2/models/Seat";

@Component({
  components: {ReservationItem, ReservationItemReadonly}
})
export default class App extends Vue implements IEventListener {
  @Prop([Number]) public id!: number | undefined | null;
  @Prop([Number]) public mode!: ReservationMode | undefined | null;
  @Prop([Number]) public subscriptionId!: number | undefined | null;
  @Prop([String]) public seatPlan!: string | undefined | null;
  @Prop([Boolean]) public isReadOnly!: boolean;
  @Prop() public map!: TicketSelectionMapController | undefined | null;

  //private map!: IBasicController | undefined | null;

  public selection: SeatSelection[] = [];

  private axiosInstance!: AxiosInstance;

  private seatApi!: SeatsApi;
  private reservationService!: SeatReservationService;

  private selectionPage = 0;
  private pageSize = 20;


  public isLoading: boolean = false;

  // public get isSearchDisabled(): boolean {
  //   return this.selected !== null && this.seats.length > 0;
  // }

  public searchCompany: boolean = false;
  private seatConfig: SeatConfigurationDto[] | null = null;
  // private subscriptionSeats: SubscriptionSeatSmallDto[] = [];
  // private eventSeats: EventSeatSmallDto[] = [];
  private existingReservations: ReservationSeatStatusDto[] = [];
  private possibleConfigs: AxiosResponse<SeatConfigurationDto[]> | null = null;
  private seats: EventSeatSmallDto [] | SubscriptionSeatSmallDto[] = [];

  private usedSeatCategories: Map<number, [string, string]> = new Map();


  public onChange(e: any) {
    debugger;
  }

  public onPageNext() {
    this.selectionPage++;
  }

  public onPagePrevious() {
    if (this.selectionPage === 0) {
      return;
    }

    this.selectionPage--;
  }

  public getCurrentStartIndex() {
    return this.selectionPage * this.pageSize;
  }

  public zoomOut() {
    this.map!.goToBoard();
  }

  public async mounted() {
    (<any>window).vm = {app: this};

    this.axiosInstance = axios.create();
    const apiConfig = new Configuration({
      basePath: ''
    });

    this.seatApi = new SeatsApi(apiConfig, '', this.axiosInstance);

    let reservationApi = new ReservationsApi(apiConfig, '', this.axiosInstance);
    this.reservationService = new SeatReservationService(reservationApi, this.id!, this.mode!);

    await this.initialize()

  }

  private async initialize() {
    this.isLoading = true;
    if (this.isReadOnly){
      this.map?.disablePlan();
    }

    if (this.mode === ReservationMode.EventMode) {
      this.seatConfig = await this.getEventConfiguration(this.id!);
      this.seats = await this.getSeatsForEvent(this.id!);

    } else if (this.mode === ReservationMode.SubscriptionMode) {
      this.seatConfig = await this.getSubscriptionConfiguration(this.id!);
      this.seats = await this.getSeatsForSubscription(this.id!);
    }

    if (!this.seatConfig) {
      return;
    }

    if (!this.seats) {
      return;
    }

    this.setCategoriesOnMap();
    
    this.seats.forEach(s => {
      if (s.state?.name != 'enabled'){
        this.map!.lockSeatBySeatCode((s.code!))
      }
    })

    this.existingReservations = await this.reservationService.getReservations(this.id!);
    this.existingReservations.forEach(s => this.map!.lockSeatBySeatCode((s.seatCode!)));

    this.selection = await this.loadCustomerReservations();
    this.selection.forEach(s => this.map!.selectSeatBySeatCode(s.seatCode, false))

    this.isLoading = false;

    setInterval( () => this.refreshReservations(), 5000);
  }
  
  private async refreshReservations() {
    let latestReservations = await this.reservationService.getReservations(this.id!); // ReservationSeatStatusDto
    let copy = Array.from(latestReservations);
    
    for (var i = 0; i < copy.length; i++){
      
      let existing = this.existingReservations.find(r => r.seatCode == copy[i].seatCode);
      if (!existing){
        if (!this.selection.find(r => r.seatCode == copy[i].seatCode)){
          this.map!.lockSeatBySeatCode(copy[i].seatCode!);
        }
      }
    }

    for (var i = 0; i < this.existingReservations.length; i++){
      let existing = copy.find(r => r.seatCode == copy[i].seatCode);
      if (!existing){
        await this.map!.freeSeatBySeatCode(copy[i].seatCode!, false);
      }
    }
   
    
}

  private setCategoriesOnMap() {
    let grouped = this.seats.reduce((g: any, seat: EventSeatSmallDto) => {
      if (
          seat.config &&
          seat.config > 0
      ) {
        g[seat.config!] = g[seat.config!] || []; //Check the value exists, if not assign a new array
        g[seat.config!].push(seat); //Push the new value to the array
      }
      return g; //Very important! you need to return the value of g or it will become undefined on the next pass
    }, {});

    let colorIndex: number = 0;
    let sortedConfigurations = Object.keys(grouped).sort();

    //this.usedSeatConfigurations = sortedConfigurations.map(c => +c);

    sortedConfigurations.forEach(c => {
      let groupedSeats = <Array<EventSeatSmallDto>>grouped[c];
      
      if (groupedSeats.filter(gs => gs.state?.name === 'enabled' ).length > 0){
        let cssClass = `seatcolor_${colorIndex++}`;
        let config = this.seatConfig?.find(conf => conf.id === groupedSeats[0].config)
        this.usedSeatCategories.set(config!.categoryId!, [config!.category!, cssClass])
        this.map!.updateSeatsWithCssClass(groupedSeats.map(s => s.code!), cssClass);
      }
    });
  }
  
  

  async getEventConfiguration(id: number) {
    try {
      let response = await this.seatApi.seatsGetConfigForEvent(id);
      return response.data;
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  async getSeatsForEvent(id: number) {
    let all: EventSeatSmallDto[] = [];
    try {
      let pagedResult: PagedResultOfEventSeatSmallDto;

      do {
        let response = await this.seatApi.seatsGetForEvent(id);
        pagedResult = response.data;
        if (pagedResult && pagedResult.results != undefined) {
          all.push(...pagedResult.results)
        }
      } while (pagedResult && pagedResult.hasMorePages)
    } catch (error) {
      console.error(error);
    }
    return all;
  }

  async getSubscriptionConfiguration(id: number) {
    try {
      let response = await this.seatApi.seatsGetConfigForSubscription(id);
      return response.data;
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  async getSeatsForSubscription(id: number) {
    let all: SubscriptionSeatSmallDto[] = [];
    try {
      let pagedResult: PagedResultOfSubscriptionSeatSmallDto;

      do {
        let response = await this.seatApi.seatsGetForSubscription(id);
        pagedResult = response.data;
        if (pagedResult && pagedResult.results != undefined) {
          all.push(...pagedResult.results)
        }
      } while (pagedResult && pagedResult.hasMorePages)
    } catch (error) {
      console.error(error);
    }
    return all;
  }

  public test() {
    if (this.map) {
      this.map.goBack();
    }
  }

  public async handle(event: string, object: any): Promise<boolean> {
    if (this.isReadOnly)
      return true;
    
    if (event === 'seatselectedEvent') {
      return await this.HandleSeatSelectedEvent(object);
    } else if (event === 'seatFreedEvent') {
      return await this.HandleSeatFreedSelectedEvent(object);
    }

    return true;
  }

  private async HandleSeatSelectedEvent(object: any) {
    let seat = this.seats.find(s => s.code == object.seatCode);
    if (seat === undefined) {
      console.error(`Seat with code ${object.seatCode} not found.`)
      return false;
    }

    let config = this.seatConfig!.find(c => c.id == seat!.config!);

    let result = await this.reservationService.createPendingReservation(seat, config!, () => {
    });

    if (result && this.selection.find((s) => s.seatCode == object.seatCode) == undefined) {

      let item = new SeatSelection(seat.code!, config!, this.usedSeatCategories.get(config!.categoryId!)![1], config!.prices![0])
      item.reservation = new ReservationInfo();
      item.reservation.reservationId = result.id!;
      item.reservation.createdOn = result.createdOn!;
      item.reservation.status = result.status!;
      item.reservation.orderId = result.orderId!;
      item.reservation.orderReference = result.orderReference!;
      item.reservation.price = result.pricing?.price!;
      item.reservation.remarks = result.remarks!;
      item.reservation.reservationCode = result.reservationCode!;

      this.selection.push(item)
    }
    return result != undefined;
  }


  // public disableSeatplan() {
  //   (<any>window).eventBus.$emit("disableSeatplan");
  // }
  //
  // public onSeatsSelected(codes: string[]) {
  //   this.seats.push(...codes);
  //   codes.forEach(c => {
  //     this.savePendingReservation(c);
  //   });
  // }
  private async HandleSeatFreedSelectedEvent(object: any) {


    let i = this.selection.findIndex((s) => s.seatCode === object.seatCode);
    if (i > -1) {
      let reservationId = this.selection[i].reservation?.reservationId;
      if (reservationId) {
        let isSuccess: boolean | undefined;
        if (this.mode == ReservationMode.EventMode){
          isSuccess = await this.reservationService.cancelPendingEventReservation(reservationId);
        }
        else  if (this.mode == ReservationMode.SubscriptionMode){
          isSuccess = await this.reservationService.cancelPendingSubscriptionReservation(this.id!, this.selection[i].seatCode)
        }
               
        if (isSuccess) {
          this.selection.splice(i, 1);
          this.map?.freeSeatBySeatCode(object.seatCode, false);

          if (this.selection.length === this.selectionPage * this.pageSize && this.selectionPage > 0) {
            this.onPagePrevious();
          }
        }
      }
    }

    return true;
  }

  get configList(): SeatConfigurationDto[] | null {
    return this.possibleConfigs?.data ?? null;
  }

  private onPriceConfigChanged(e: { SeatSelection: SeatSelection, SelectedPricing: Pricing }) {
    // e.SeatSelection.selectedPricing = e.SelectedPricing;
    if (this.mode == ReservationMode.EventMode) {
      let updateRequest = <PublicUpdateEventReservationModel>{
        priceId: e.SeatSelection.selectedPricing?.id,
        reservationId: e.SeatSelection.reservation?.reservationId,
        language: 'nld',
        reservationCode: e.SeatSelection.reservation?.reservationCode
      }
      this.reservationService.updatEventReservation([updateRequest])
    } else if (this.mode == ReservationMode.SubscriptionMode) {
      let updateRequest = <PublicUpdateSubscriptionReservationModel>{
        priceId: e.SeatSelection.selectedPricing?.id,
        subscriptionId: this.id,
        language: 'nld',
        seatCode: e.SeatSelection.seatCode,
      }
      this.reservationService.updateSubscriptionReservation([updateRequest])
    }
  }


  private async loadCustomerReservations(): Promise<SeatSelection[]> {
    let reservations = await this.reservationService.getCustomerReservations()

    let result = new Array<SeatSelection>();

    for (const res of reservations) {
      let eventSeat = this.seats.find(s => s.code === res.seatCode);
      let sc = this.seatConfig!.find(c => c.id == eventSeat!.config);

      let selectedPricing: Pricing | undefined = undefined;

      if (res.pricing && res.pricing!.priceId! > 0) {
        let pricing;
        if (this.mode === ReservationMode.EventMode){
          pricing = sc!.prices?.find(p => p.id == res.pricing?.eventSeatPriceId);
        } 
        else if (this.mode === ReservationMode.SubscriptionMode){
          pricing = sc!.prices?.find(p => p.id == res.pricing?.subscriptionSeatPriceId);
        }
        
        if (pricing) {
          selectedPricing = {
            id: pricing.id,
            category: pricing.category,
            amount: pricing.amount,
            categoryId: pricing.categoryId
          };
        }
      }

      let item = new SeatSelection(res.seatCode!, sc!, this.usedSeatCategories.get(sc!.categoryId!)![1], selectedPricing, res.pricing?.price)
      item.reservation = new ReservationInfo();
      item.reservation.reservationId = res.id!;
      item.reservation.createdOn = res.createdOn!;
      item.reservation.status = res.status!;
      item.reservation.orderId = res.orderId!;
      item.reservation.orderReference = res.orderReference!;
      item.reservation.price = res.pricing?.price!;
      item.reservation.remarks = res.remarks!;
      item.reservation.reservationCode = res.reservationCode!;
      result.push(item);

    }
    return result;
  }
}

